module.exports = false;



//////////////////
// WEBPACK FOOTER
// /buddy/wp/web/app/themes/qol/node_modules/core-js/modules/_library.js
// module id = 31
// module chunks = 0